import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      let attempts = 0;

      const scrollToHash = () => {
        const target = document.getElementById(hash.replace("#", ""));
        if (!target && attempts < 12) {
          attempts += 1;
          setTimeout(scrollToHash, 80);
          return;
        }

        if (!target) return;

        const top = target.getBoundingClientRect().top + window.scrollY - 104;
        window.scrollTo({ top, behavior: "smooth" });
      };

      scrollToHash();
      return;
    }

    window.scrollTo(0, 0);
  }, [hash, pathname]);

  return null;
};

export default ScrollToTop;
